<template>
  <div class="excercise-layout">

    <header class="bg-primary text-white text-center py-5 practica-header">
      <h2 class="h4">Práctica</h2>
      <img
        class="mt-3"
        style="border: solid 2px #fff; border-radius: 7px"
        src="@/assets//images/icons/trigonometry.svg"
        alt="Trigonometría"
      />
      <h1 class="h3 mt-3">{{ currentQuestion && currentQuestion.category }}</h1>
    </header>

    <main class="container mt-n5" v-if="currentQuestion">

      <div class="row">
        <!-- Question container -->
        <div class="col-12 col-md-8">
          <div class="card px-3 py-3 px-md-5 py-md-5 position-relative">
            <!-- Hint button -->
            <div class="hint-container" :class="{ active: showHint }" v-if="getQuestionHint(currentQuestion.hint) !== ''">
              <button class="hint-button" @click="toggleHint">
                <div class="inner-content">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.032 18.951l5.795 1.553-.518 1.932-5.795-1.553.518-1.932zm9.264-4.027c1.307-.899 2.657-1.828 3.242-4.01.999-3.728-1.222-7.574-4.95-8.573-3.727-.999-7.574 1.222-8.573 4.95-.591 2.207.117 3.684.805 5.112.238.497.484 1.01.698 1.584.086.236.11 1.06.074 2.008l-.75-.2-.517 1.931 7.727 2.07.518-1.931-.748-.2c.446-.84.88-1.544 1.071-1.706.47-.395.944-.72 1.403-1.035zm-2.687-.5c-.579.484-1.306 1.799-1.767 2.71l-2.271-.608c.057-1.022.085-2.528-.18-3.237a20.501 20.501 0 00-.769-1.75c-.647-1.348-1.075-2.24-.675-3.73a5.006 5.006 0 016.123-3.536 5.006 5.006 0 013.536 6.123c-.394 1.47-1.21 2.03-2.443 2.88-.474.326-1.01.694-1.554 1.148z"/>
                  </svg>
                  <span>¿Necesitas ayuda?</span>
                </div>
              </button>
              <div  v-if="showHint" class="mt-3">
                <p id="hint">  {{ currentQuestion.hint }}</p>
              </div>
            </div>

            <!-- Question sentence: allow image to display fully (wider container) -->
            <div style="max-width: 800px; margin: auto">
              <p id="question">{{ currentQuestion.description }}</p>
              <p class="text-center">
                <img
                  v-if="currentQuestion.graph && !currentQuestion.graphUrl"
                  :src="getGraphUrl(currentQuestion.graph)"
                  alt="imagen"
                  class="mt-3 mb-5 img-fluid"
                  style="max-width: 100%; width: auto; height: auto"
                />
                <img
                  v-if="currentQuestion.graphUrl"
                  :src="currentQuestion.graphUrl"
                  alt="imagen"
                  class="mt-3 mb-5 img-fluid"
                  style="max-width: 100%; width: auto; height: auto"
                />
              </p>
            </div>
            <!-- End Question sentence -->

            <!-- Question Form (multiple choice only) -->
            <form v-if="!isOpenEnded && currentQuestion.answers && currentQuestion.answers.length" id="quetions-form" style="max-width: 500px; margin: auto">
              <div class="mb-3">
                <div
                  class="question-option"
                  v-for="(option, index) in currentQuestion.answers"
                  :key="index"
                  :class="selectedOptionClasses(index)"
                >
                  <label
                    class="d-flex flex-row justify-content-between mb-0 py-2 px-2 px-md-4"
                    :for="'question-option-' + index"
                  >
                    <div class="d-flex flex-column">
                      <div>
                        <input
                          name="question-option"
                          class="mr-2"
                          type="radio"
                          :id="'question-option-' + index"
                          :value="index"
                        />
                        <span :id="'answer-option-' + index">{{ option.description }}</span>
                      </div>
                      <img v-if="option.graphUrl" :src="option.graphUrl" alt="" class="mt-1 rounded" style="max-width: 140px;" />
                    </div>
                    <div class="ml-3">
                      <span
                        v-if="option.correct"
                      >Correcta</span
                      >
                    </div>
                  </label>
                </div>
              </div>
            </form>
            <p v-else-if="isOpenEnded" class="text-muted font-italic" style="max-width: 500px; margin: auto">Respuesta abierta (el estudiante escribe su respuesta)</p>
            <!-- End Question Form-->

            <!-- Question answer / reference solution (solution for MCQ, reference answer for open-ended) -->
            <div v-if="answered && (currentQuestion.solution || currentQuestion.referenceAnswer)" class="border rounded mt-5">
              <div class="px-4 py-2 border-bottom text-center bg-light">
                <h3 class="m-0 h5">{{ isOpenEnded ? 'Respuesta de referencia' : 'Solución' }}</h3>
              </div>
              <div class="p-4">
                <p style="word-wrap: break-word;" id="solution">{{ currentQuestion.solution || currentQuestion.referenceAnswer }}</p>
              </div>
            </div>
            <!-- End Question answer -->
          </div>
        </div>
        <!-- End Question container -->

        <!-- Sidebar -->
        <div class="col-12 col-md-4">
          <div class="card">
            <div>
              <p class="font-weight-bold mb-2">Dificultad</p>
              <div class="d-flex align-items-center">
                <img src="@/assets/images/icons/dificultad.svg" alt="" />
                <p class="font-weight-light m-0 ml-2">
                  {{ currentQuestion.difficulty }}
                </p>
              </div>
            </div>
            <div class="mt-3">
              <p class="font-weight-bold mb-2">Área de conocimiento</p>
              <div class="d-flex align-items-center">
                <img src="@/assets/images/icons/conocimiento.svg" alt="" />
                <p class="font-weight-light m-0 ml-2">
                  {{ currentQuestion.category }}
                </p>
              </div>
            </div>
            <div class="mt-3">
              <p class="font-weight-bold mb-2">Tipos de pensamiento</p>
              <div class="d-flex align-items-center">
                <img src="@/assets/images/icons/pensamientos.svg" alt="" />
                <p class="font-weight-light m-0 ml-2">
                  {{ currentQuestion.knowledge_area }}
                </p>
              </div>
            </div>
          </div>
          <div class="card">
             <span v-if="goBack === 'create'">
                <router-link :to="{ name: 'QuestionsCreate', params: { id: null, formEdit: this.form}}" >
                <b-button variant="primary" class="btn btn-primary w-100">
                  Seguir Editando
                </b-button>
              </router-link>
             </span>
            <span v-if="goBack && goBack !== 'create' && !fromList ">
                <router-link :to="{ name: 'QuestionsEdit', params: { id: this.goBack, formEdit: this.form}}" >
                <b-button variant="primary" class="btn btn-primary w-100">
                  Seguir Editando
                </b-button>
              </router-link>
             </span>
            <button class="btn btn-primary w-100" v-if="!goBack || fromList" @click="goToDashboard">
              <span >Salir de la vista previa</span>
            </button>
          </div>
          <p class="text-gray-600 font-italic " style="font-size: 12px"> {{ currentQuestion.uniqueName }} </p>
        </div>
      </div>
      <!-- End Sidebar -->
    </main>
  </div>
</template>

<script>

import axios from "axios";
import assetImport from "@/Utils/asset-import.js";

export default {
  name: "Exercise",
  props: ["topic", "goBack", "form", "fromList"],
  data: () => {
    return {
      currentQuestion: null,
      questions: null,
      selectedOption: null,
      counter: 0,
      attempts: null,
      correctAnswers: 0,
      answered: false,
      isReview: false,
      firstLoad: true,
      showHint: false,
      difficulties: [],
      acknowledges: [],
      categories: []
    };
  },
  beforeRouteLeave (to, from , next) {

    if (to.name !== 'QuestionsCreate' && to.name !== 'QuestionsEdit' && this.goBack && !this.fromList) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else next();
  },
  computed: {
    isOpenEnded() {
      return this.currentQuestion && this.currentQuestion.questionType === 'OPEN_ENDED';
    },
  },
  methods: {
    getQuestionHint: function(hint){
      const elements = document.getElementById("hint");
      if (!hint || hint === "NaN") return "";
      if (elements){
        elements.innerText = hint;
      } else {
        return hint;
      }
    },
    getGraphUrl(graphName) {
      if (graphName === "NaN") return "";
      try {
        return assetImport("../../../../assets/images/graphs/" + graphName + ".svg");
      } catch (e) {
        console.log("Gráfica no encontrada: " + graphName)
        return "";
      }
    },
    setQuestionToView() {
      if (this.form) {
        this.setQuestion(this.form, true)
      }else {
        if (this.$route.params.id) {
          axios
            .get(
              import.meta.env.VITE_API_BASE_URL + "/api/question/" + this.$route.params.id,
              {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("token"),
                },
              }
            )
            .then((response) => {
              this.setQuestion(response.data, false)
            })
            .catch((err) => {
              console.log(err.message);
            });
        }
      }
    },
    loadCategory() {
      axios
        .get(
          import.meta.env.VITE_API_BASE_URL + "/api/categories/list",
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          this.categories = response.data;
          this.setQuestionToView();
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    loadKnowledge() {
      axios
        .get(
          import.meta.env.VITE_API_BASE_URL + "/api/knowledgearea/list",
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          this.acknowledges = response.data;
          this.loadCategory();
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    getDifficulties() {
      axios
        .get(
          import.meta.env.VITE_API_BASE_URL + "/api/difficulty/list",
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
         this.difficulties =  response.data;
         this.loadKnowledge();
        })
        .catch((err) => {
          console.log(err.message);
        });

    },
    setQuestion(questionInfo, isEditing) {
      let excercice = {};
      const questionType = questionInfo.questionType || 'MULTIPLE_CHOICE';
      const isOpenEnded = questionType === 'OPEN_ENDED';

      if (isEditing) {
        excercice.knowledge_area = this.acknowledges.find(x => x.id === questionInfo.knowledgeArea)?.description;
        excercice.category = this.categories.find(x => x.id === questionInfo.category)?.description;
        excercice.difficulty = this.difficulties.find(x => x.id === questionInfo.difficulty)?.description;
        if (isOpenEnded) {
          excercice.answers = [];
        } else {
          const url = (i) => (questionInfo['answerGraphUrl' + i] || questionInfo['answerGraphName' + i]) || null;
          excercice.answers = [
            { description: questionInfo.answer1, correct: questionInfo.correctAnswer === 'A', graphUrl: url(1) },
            { description: questionInfo.answer2, correct: questionInfo.correctAnswer === 'B', graphUrl: url(2) },
            { description: questionInfo.answer3, correct: questionInfo.correctAnswer === 'C', graphUrl: url(3) },
            { description: questionInfo.answer4, correct: questionInfo.correctAnswer === 'D', graphUrl: url(4) },
            { description: questionInfo.answer5, correct: questionInfo.correctAnswer === 'E', graphUrl: url(5) },
            { description: questionInfo.answer6, correct: questionInfo.correctAnswer === 'F', graphUrl: url(6) }
          ];
        }
      } else {
        excercice.category = questionInfo.category;
        excercice.knowledge_area = questionInfo.knowledge_area?.description;
        excercice.difficulty = questionInfo.difficulty?.description;
        excercice.answers = (questionInfo.answers || []).slice();
        excercice.answers.sort(function (a, b) {
          return parseInt(a.position) - parseInt(b.position);
        });
      }

      excercice.questionType = questionType;
      excercice.uniqueName = questionInfo.uniqueName;
      excercice.description = questionInfo.description;
      // Show reference answer in solution block for open-ended (like solution for MCQ)
      excercice.solution = isOpenEnded ? (questionInfo.referenceAnswer || '') : (questionInfo.solution || '');
      excercice.referenceAnswer = questionInfo.referenceAnswer || '';
      excercice.hint = questionInfo.hint;
      excercice.graph = questionInfo.graph;
      excercice.graphName = questionInfo.graphName ? questionInfo.graphName : questionInfo.graphUrl;
      excercice.graphUrl = questionInfo.graphUrl;

      if (excercice.selectedOption != null) {
        this.selectedOption = excercice.selectedOption;
        this.answered = true;
        this.isReview = true;
      } else {
        this.isReview = false;
        this.answered = false;
      }

      this.$nextTick(function () {
        this.currentQuestion = excercice;
        this.answered = true;
      });

    },
    selectedOptionClasses: function (index) {
      if (this.answered === true && this.currentQuestion.answers && this.currentQuestion.answers[index]) {
        return {
          "question-option--correct": this.currentQuestion.answers[index].correct,
          "question-option--incorrect": !this.currentQuestion.answers[index].correct
        };
      }
      return {};
    },
    goToDashboard() {
      if (this.goBack === 'create') {
        this.$router.replace({
          path: `/admin-panel/questions/` + this.goBack,
          params: {  formEdit: this.form}
        });
      } else if (this.goBack instanceof Object) {
        this.$router.replace({
          path: `/admin-panel/questions?` ,
          query:  this.goBack
        });
      } else if (this.goBack) {

        this.$router.replace({
          path: `/admin-panel/questions/` + this.goBack,
          params: {  formEdit: this.form}
        });
      } else {
          this.$router.replace({
          path: `/admin-panel/`,
      });
      }
    },
    toggleHint() {
      this.showHint = !this.showHint;
    },
  },
  watch: {
    currentQuestion: function () {
      if ('MathJax' in window) {
        this.$nextTick(function() {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        });
      }
    },
    showHint: function () {
      if ('MathJax' in window) {
        this.$nextTick(function() {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        });
      }
    },
    answered: function () {
      if ('MathJax' in window) {
        this.$nextTick(function() {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        });
      }
    }
  },
  beforeMount() {
    this.getDifficulties();
    (function () {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML";
      document.getElementsByTagName("head")[0].appendChild(script);
    })();

  },
  mounted() {

  },
};
</script>

<style src="@/assets/css/app.css"></style>
